module.exports = __webpack_public_path__ + "img/discoarado.7aef9d17.png";